import { createFileRoute } from "@tanstack/react-router";
import { DefiProtocolTokensPage } from "../../features/defi/pages/defi-protocol-tokens-page";

export const Route = createFileRoute("/_layout/defi/protocols/$protocolKey")({
  component: DefiProtocolTokensPage,
});
